seedWebApp.controller('DashboardQuotesController', ['$scope', '$rootScope', '$window', '$route','ToastService', 'StoreService',
    function ($scope, $rootScope, $window, $route, ToastService, StoreService) {
        console.log('dashboardQuotesController');

        //$scope.orders = [];

        /*
        var order = {
            OrderID: 'TSW2022.00001',
            StatusID: 'ANÁLISE',
        };
        $scope.orders.push(order);

        $scope.orders.push(
            {
            OrderID: 'TSW2022.00002',
            StatusID: 'ANÁLISE',
            }
        );

        $scope.orders.push(
            {
                OrderID: 'TSW2022.00003',
                StatusID: 'ANÁLISE',
            }
        );
        */

        

        //$scope.loadQuotes('');
    }]
);

